module.exports = __webpack_public_path__ + "static/media/submitted.bbaa06ec.svg";